module.exports = __webpack_public_path__ + "static/media/daily_menu_item.17d0d0bc.svg";